export default __webpack_public_path__ + "static/media/VO_BR.7ed74629.gif";